import { Badge, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  active: {
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorPaletteGreenForeground2,
  },
  unclaimed: {
    backgroundColor: tokens.colorPaletteYellowBackground2,
    color: tokens.colorPaletteYellowForeground2,
  },
  unknown: {
    backgroundColor: tokens.colorNeutralBackground5,
    color: tokens.colorNeutralForeground3,
  },
});

/**
 * User account status. EHR's `UserAccountStatus` has exactly two members — `active` and
 * `unclaimed` (an invited account that has never been signed into) — and no disabled state,
 * so anything else is a value hub does not know about and is shown verbatim rather than
 * being flattened into a wrong label. Organizations and facilities have no status field in
 * EHR at all and therefore never render a badge.
 */
export function StatusBadge({ status }: { status: string }) {
  const classes = useStyles();
  if (status === 'active') {
    return <Badge appearance="filled" className={classes.active}>Active</Badge>;
  }
  if (status === 'unclaimed') {
    return <Badge appearance="filled" className={classes.unclaimed}>Unclaimed</Badge>;
  }
  // A blank value is a malformed status the projector deliberately preserved; rendering it
  // verbatim would be an empty badge the reader cannot even see.
  return (
    <Badge appearance="filled" className={classes.unknown}>
      {status.trim() === '' ? 'Unknown' : status}
    </Badge>
  );
}
